module.exports = require('./lib/no-important.js'); // eslint-disable-line import/no-unresolved



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-with-styles-interface-aphrodite/no-important.js
// module id = 393
// module chunks = 0